"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
var EmailVerifyConfirm = function () {
    var t = (0, next_intl_1.useTranslations)();
    var tError = (0, next_intl_1.useTranslations)('errors');
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var openEmailVerify = (0, apps_shared_1.useOpenEmailVerify)();
    var _a = (0, react_1.useState)(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = (0, react_1.useState)(''), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(false), isMounted = _c[0], setIsMounted = _c[1];
    var reportCommonError = (0, swr_hooks_1.useReportCommonError)().reportCommonError;
    var searchParams = (0, navigation_1.useSearchParams)();
    var token = (0, react_1.useMemo)(function () { return searchParams.get('token'); }, [searchParams]);
    var _d = (0, swr_hooks_1.useVerifyEmail)({
        successAction: function () {
            setError('');
            setIsLoading(false);
        },
        errorAction: function (e) {
            setIsLoading(false);
            setError(e);
        },
    }), isSubmitting = _d.isSubmitting, verifyEmail = _d.verifyEmail;
    (0, react_1.useEffect)(function () {
        setIsMounted(true);
    }, []);
    (0, react_1.useEffect)(function () {
        if (!isMounted)
            return;
        if (token) {
            verifyEmail({ token: token });
        }
        /* eslint-disable-next-line */
    }, [token, isMounted]);
    var handleError = function (error, errorInfo) {
        var _a, _b;
        reportCommonError({
            errorMessage: "EMAIL CONFIRM VERIFICATION: ".concat(error, " | STACK: ").concat(errorInfo.componentStack),
            errorName: error,
            reqUrl: (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) !== null && _b !== void 0 ? _b : '',
        });
    };
    if (!isMounted)
        return null;
    return (react_1.default.createElement(ErrorBoundary_1.default, { onError: handleError },
        react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "auto", padding: "24px 16px", saveSize: true },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
                isLoading && react_1.default.createElement(ui_components_1.LoadingWithContainer, null),
                error && (react_1.default.createElement("div", null,
                    react_1.default.createElement("h1", { dangerouslySetInnerHTML: {
                            __html: t('emailVerification.vefiryEmail'),
                        } }),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.error }, tError(error)),
                    react_1.default.createElement(ui_components_1.FixedButton, { type: "button", color: "gradient", text: "upper", height: "42px", maxWidth: "320px", onClick: openEmailVerify },
                        react_1.default.createElement("span", null, t('emailVerification.verifyBtn'))))),
                !isLoading && !error && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("img", { src: "/img/email/email-verify.png", alt: "email-verify" }),
                        react_1.default.createElement("h1", { dangerouslySetInnerHTML: {
                                __html: t('emailVerification.successVerifyTitle'),
                            } }),
                        react_1.default.createElement("p", null, t('emailVerification.successVerifyText'))),
                    react_1.default.createElement(ui_components_1.FixedButton, { type: "button", color: "gradient", text: "upper", height: "42px", maxWidth: "320px", onClick: closeModal, loading: isSubmitting },
                        react_1.default.createElement("span", null, t('translation.ok')))))))));
};
exports.default = EmailVerifyConfirm;
